<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Custom</h2>
    </div>

    <div class="part__cnt">
      <div class="label_style mt-3">
        <ul v-for="item in custom" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div>
        <div v-show="chartDatacustom?.rows?.monomem?.length" class="position-relative">
          <div id="monomem" style="width: 100%; height: 500px"></div>
          <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="monomem_chart" />
          <chart-rect ref="chartRect1" chartKey="monomem_chart" />
        </div>
        <br />
        <div v-show="chartDatacustom?.rows?.gc?.length" class="position-relative">
          <div id="gc_line" style="width: 100%; height: 400px"></div>
          <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="gc_line_chart" />
          <chart-rect ref="chartRect2" chartKey="gc_line_chart" />
        </div>
        <br />
        <div v-show="chartDatacustom?.rows?.dc?.length" class="position-relative">
          <div id="dc_line" style="width: 100%; height: 400px"></div>
          <label-list ref="labelList3" :perf_second_data="perf_second_data" chartKey="dc_line_chart" />
          <chart-rect ref="chartRect3" chartKey="dc_line_chart" />
        </div>
        <br />
        <div v-show="chartDatacustom?.rows?.Tris?.length" class="position-relative">
          <div id="Tris" style="width: 100%; height: 400px"></div>
          <label-list ref="labelList4" :perf_second_data="perf_second_data" chartKey="Tris_chart" />
          <chart-rect ref="chartRect4" chartKey="Tris_chart" />
        </div>
        <br />
        <div v-show="chartDatacustom?.rows?.Verts?.length" class="position-relative">
          <div id="Verts" style="width: 100%; height: 400px"></div>
          <label-list ref="labelList5" :perf_second_data="perf_second_data" chartKey="Verts_chart" />
          <chart-rect ref="chartRect5" chartKey="Verts_chart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    chartDatacustom() {
      return this.perf_second_data?.['自定义数据']
    },
  },

  methods: {
    getMonomemOption(){
      return {
        title: {
          text: "Mono Memory",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom?.rows?.timeline,
        },
        series: [
          {
            name: "monomem",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom?.rows?.monomem,
            itemStyle: this.chartSettings.itemStyle2,
            // markLine: {
            //   symbol: ["circle", "arrow"],
            //   data: [
            //     {
            //       silent: true,
            //       xAxis: this.month_new,
            //       label: {
            //         position: "end",
            //         show: true,
            //         formatter: this.month_new,
            //         color: "ED5664",
            //       },
            //       lineStyle: {
            //         type: "solid",
            //         color: "#ED5664",
            //         width: "1",
            //         opacity: this.opacity, // 设置为0，使标记线不可见
            //       },
            //     },
            //   ],
            // },
          },
        ],
      }
    },

    drawPieChartMonomem() {
      let chartDom = document.getElementById("monomem")
      if (!chartDom) return
      if (!allChart.monomem_chart) {
        allChart.monomem_chart = echarts.init(chartDom)
      }
      allChart.monomem_chart.setOption(this.getMonomemOption(), {notMerge: true})
    },

    getGcOption() {
      return {
        title: {
          text: "GC",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom?.rows?.timeline,
        },
        series: [
          {
            name: "gc_line",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom?.rows?.gc,
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartGc() {
      let chartDom = document.getElementById("gc_line")
      if (!chartDom) return
      if (!allChart.gc_line_chart) {
        allChart.gc_line_chart = echarts.init(chartDom)
      }
      allChart.gc_line_chart.setOption(this.getGcOption(), {notMerge: true})
    },

    getDcOption() {
      return {
        title: {
          text: "DrawCall",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom?.rows?.timeline,
        },
        series: [
          {
            name: "dc_line",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom?.rows?.dc,
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartDc() {
      let chartDom = document.getElementById("dc_line")
      if (!chartDom) return
      if (!allChart.dc_line_chart) {
        allChart.dc_line_chart = echarts.init(chartDom)
      }
      allChart.dc_line_chart.setOption(this.getDcOption(), {notMerge: true})
    },

    getTrisOption() {
      return {
        title: {
          text: "三角形数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom?.rows?.timeline,
        },
        series: [
          {
            name: "Tris",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom?.rows?.Tris,
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartTris() {
      let chartDom = document.getElementById("Tris")
      if (!chartDom) return
      if (!allChart.Tris_chart) {
        allChart.Tris_chart = echarts.init(chartDom)
      }
      allChart.Tris_chart.setOption(this.getTrisOption(), {notMerge: true})
    },

    getVertsOption() {
      return {
        title: {
          text: "顶点数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDatacustom?.rows?.timeline,
        },
        series: [
          {
            name: "Verts",
            type: "line",
            showSymbol: false,
            data: this.chartDatacustom?.rows?.Verts,
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartVerts() {
      let chartDom = document.getElementById("Verts")
      if (!chartDom) return
      if (!allChart.Verts_chart) {
        allChart.Verts_chart = echarts.init(chartDom)
      }
      allChart.Verts_chart.setOption(this.getVertsOption(), {notMerge: true})
    },

    drawCharts() {
      this.drawPieChartMonomem()
      this.drawPieChartGc()
      this.drawPieChartDc()
      this.drawPieChartTris()
      this.drawPieChartVerts()
    },
  }
}

export default {
  mixins: [useCharts],

  components: {LabelList, ChartRect},

  inject: ['injectObj'],

  props: {
    testInfo0: Object,
    testInfo2: Object,
    testInfo3: Object,
  },

  computed: {
    project() {
      return this.$route.query.project
    },

    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    custom() {
      let data = this.testInfo3

      let result = [
        {
          label: "Mono堆内存峰值(MB)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
        },
        {
          label: "GC次数",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
        },
        {
          label: "DrawCall均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
        },
        {
          label: "三角形数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
        },
        {
          label: "顶点数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
        },
      ];
      if (
        this.testInfo0?.proj_name === "CF手游" ||
        this.testInfo0?.proj_name === "CFM手游测试"
      ) {
        result = [
          {
            label: "Mono堆内存峰值(MB)",
            value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
          },
          {
            label: "GC次数",
            value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
          },
          {
            label: "DrawCall均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
          },
          {
            label: "三角形数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
          },
          {
            label: "顶点数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
          },
          {
            label: "DrawCall最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_dc,
          },
          {
            label: "三角形数最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_triangle,
          },
          {
            label: "顶点数最大值",
            value:
              JSON.stringify(data) === "{}"
                ? "-"
                : data?.custom_data
                ? JSON.parse(data?.custom_data || "{}")?.max_vertices
                : "-",
          },
        ];
      }

      return result
    },
  },

  data() {
    return {

    }
  },

  methods: {
    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
      this.$refs.chartRect3?.init(isMounted)
      this.$refs.chartRect4?.init(isMounted)
      this.$refs.chartRect5?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>